import { AppState } from "features";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { catchError, mergeMap } from "rxjs/operators";
import { of } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CommunicationsApiService } from "../../services/api/communications-api.service";
import {
	CommunicationActionTypes,
	LoadCommunicationByPsId,
	LoadCommunicationError,
	LoadCommunicationSuccess,
} from "./communication.action";
import { OperatingSystemHelperService } from "../../services/helpers/operating-system-helper.service";
import { cloneDeep } from "lodash-es";
import { Communication } from "@models/communication.model";

@Injectable()
export class CommunicationEffect {
	constructor(
		private actions$: Actions,
		private communicationApiService: CommunicationsApiService,
		private store: Store<AppState>,
	) {}

	loadCommunication$ = createEffect(() =>
		this.actions$.pipe(
			ofType<LoadCommunicationByPsId>(CommunicationActionTypes.LoadCommunicationByPsId),
			mergeMap((action) => {
				return this.communicationApiService.getCommunicationsByPsId(action.payload).pipe(
					mergeMap((communications) => {
						if (!communications?.length) return of(new LoadCommunicationError("NO_COMMUNICATIONS_FOUND"));
						const osInfo = OperatingSystemHelperService.getOsInformations();
						let path = `emotionlink/${osInfo.osName}`;
						if (osInfo.osName === "Window" && +osInfo.majorVersion < 8) {
							path = `emotionlink/${osInfo.osName}/7`;
						}
						let data = null;
						communications.forEach((communication) => {
							const isMatched = OperatingSystemHelperService.comparePathContext(
								path,
								communication.contexte,
							);
							if (isMatched) {
								data = {};
								data["id"] = communication.idCommunication;
								data["modeCommunication"] = communication.mode;
							}
						});
						if (!data) return of(new LoadCommunicationError("OS_INCOMPATIBLE"));
						return this.communicationApiService.getCommunication(data.id, data.modeCommunication).pipe(
							mergeMap((communication) => {
								const communicationClone = cloneDeep(communication) as Communication;
								const iframeRegex = /<iframe.*?<\/iframe>/i;
								const iframeTagMatch = communication.contenu.match(iframeRegex);

								if (iframeTagMatch) {
									const iframeTag = iframeTagMatch[0];
									communicationClone.contenu = iframeTag;
									return of(new LoadCommunicationSuccess(communicationClone));
								}
								return of(null);
							}),
							catchError((err) => of(new LoadCommunicationError(err))),
						);
					}),
					catchError((err) => of(new LoadCommunicationError(err))),
				);
			}),
			catchError((err) => of(new LoadCommunicationError(err))),
		),
	);
}
